module.exports = __webpack_public_path__ + "img/hospital-regular.7c9eec0b.svg";